"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObjectPropertyManipulator = exports.InlineObjectManipulator = void 0;
var tslib_1 = require("tslib");
var inline_object_run_property_changed_1 = require("../changes/sub-document/picture/inline-object-run-property-changed");
var history_item_state_1 = require("../history/states/history-item-state");
var history_item_state_object_1 = require("../history/states/history-item-state-object");
var json_floating_enums_1 = require("../json/enums/json-floating-enums");
var base_manipulator_1 = require("./base-manipulator");
var InlineObjectManipulator = (function (_super) {
    tslib_1.__extends(InlineObjectManipulator, _super);
    function InlineObjectManipulator(manipulator) {
        var _this = _super.call(this, manipulator) || this;
        _this.scale = new InlineObjectScaleManipulator(manipulator);
        _this.lockAspectRatio = new InlineObjectLockAspectRatioManipulator(manipulator);
        return _this;
    }
    return InlineObjectManipulator;
}(base_manipulator_1.BaseManipulator));
exports.InlineObjectManipulator = InlineObjectManipulator;
var InlineObjectPropertyManipulator = (function (_super) {
    tslib_1.__extends(InlineObjectPropertyManipulator, _super);
    function InlineObjectPropertyManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineObjectPropertyManipulator.prototype.setValue = function (subDocument, interval, newValue) {
        var oldState = new history_item_state_1.HistoryItemIntervalState();
        var newState = new history_item_state_1.HistoryItemIntervalState();
        var run = subDocument.getRunByPosition(interval.start);
        oldState.register(new history_item_state_object_1.HistoryItemInlineObjectPropertiesStateObject(interval, this.getPropertyValue(run.size)));
        newState.register(new history_item_state_object_1.HistoryItemInlineObjectPropertiesStateObject(interval, newValue));
        this.setPropertyValue(run.size, newValue);
        this.modelManipulator.notifyModelChanged(new inline_object_run_property_changed_1.InlineObjectRunPropertyChangedSubDocumentChange(subDocument.id, this.getJSONInlineObjectProperty(), interval.start, newState));
        return oldState;
    };
    InlineObjectPropertyManipulator.prototype.restoreValue = function (subDocument, state) {
        if (state.isEmpty())
            return;
        var stateValue = state.lastObject;
        var run = subDocument.getRunByPosition(stateValue.interval.start);
        this.setPropertyValue(run.size, stateValue.value);
        this.modelManipulator.notifyModelChanged(new inline_object_run_property_changed_1.InlineObjectRunPropertyChangedSubDocumentChange(subDocument.id, this.getJSONInlineObjectProperty(), state.interval.start, state));
    };
    return InlineObjectPropertyManipulator;
}(base_manipulator_1.BaseManipulator));
exports.InlineObjectPropertyManipulator = InlineObjectPropertyManipulator;
var InlineObjectScaleManipulator = (function (_super) {
    tslib_1.__extends(InlineObjectScaleManipulator, _super);
    function InlineObjectScaleManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineObjectScaleManipulator.prototype.getPropertyValue = function (size) {
        return size.scale.clone();
    };
    InlineObjectScaleManipulator.prototype.setPropertyValue = function (size, value) {
        size.scale.width = value.width;
        size.scale.height = value.height;
    };
    InlineObjectScaleManipulator.prototype.getJSONInlineObjectProperty = function () {
        return json_floating_enums_1.JSONInlineObjectProperty.Scales;
    };
    return InlineObjectScaleManipulator;
}(InlineObjectPropertyManipulator));
var InlineObjectLockAspectRatioManipulator = (function (_super) {
    tslib_1.__extends(InlineObjectLockAspectRatioManipulator, _super);
    function InlineObjectLockAspectRatioManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineObjectLockAspectRatioManipulator.prototype.getPropertyValue = function (size) {
        return size.lockAspectRatio;
    };
    InlineObjectLockAspectRatioManipulator.prototype.setPropertyValue = function (size, value) {
        size.lockAspectRatio = value;
    };
    InlineObjectLockAspectRatioManipulator.prototype.getJSONInlineObjectProperty = function () {
        return json_floating_enums_1.JSONInlineObjectProperty.LockAspectRatio;
    };
    return InlineObjectLockAspectRatioManipulator;
}(InlineObjectPropertyManipulator));
